import { Button } from 'rsuite';
import { icons } from '@shared/static/icons';

export default function ThemeButton({
  children,
  type,
  as = 'button',
  href,
  target,
  className = '',
  onClick,
  loading = false,
  disabled = false,
  block = true,
  appearance = 'primary',
  startIcon,
  endIcon,
  minWidth = false,
}) {
  return (
    <Button
      startIcon={icons[startIcon]}
      endIcon={icons[endIcon]}
      appearance={appearance}
      type={type}
      as={as}
      href={href}
      target={target}
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      block={block}
      className={`${className} ${minWidth ? 'min-width' : ''}`.trim()}
    >
      {children}
    </Button>
  );
}
